import React from 'react'
import {Modal, Button} from 'react-bootstrap-v5'

type Props = {
  open: boolean
  region: string
  onYes: () => void
  onNo: () => void
}

const ForkliftPromptModal: React.FC<Props> = ({open, region, onYes, onNo}) => (
  <Modal show={open} onHide={onNo} centered size='sm'>
    <Modal.Header>
      <Modal.Title>Delivery Question</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p className='text-center text-dark' style={{fontSize: 14, marginBottom: 0}}>
        Your postcode appears to be in <b>{region}</b>.<br/>
        Will you have a forklift on site to unload?
      </p>
    </Modal.Body>
    <Modal.Footer>
      <Button variant='primary' onClick={onYes}>Yes</Button>
      <Button variant='secondary' onClick={onNo}>No</Button>
    </Modal.Footer>
  </Modal>
)

export default ForkliftPromptModal
